import './App.css';
import { Home } from './components/Home';
import { EditorPage } from './components/EditorPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import POC from './components/POC';
function App() {
  
  return (
    <React.Fragment>  
      <div className="">
        <Router>
          <Routes>
            <Route path='/' element={<EditorPage />} />
            <Route path='/editor-page' element={<EditorPage />} />
            <Route path='/poc-page' element={<POC />} />
          </Routes>
        </Router>
      </div>
    </React.Fragment>
  );
}

export default App;
